import { apiAxios } from './apiConfig';

export type FunnelFeature = 'TRIAL' | 'DIAGNOSE';
export type FunnelEventType = 'START' | 'RESULT_SHOWN' | 'SIGNUP_CTA_CLICK';

export type FunnelStats = Record<FunnelFeature, Record<FunnelEventType, number>>;

export interface UsageToday {
  trial: { globalCount: number; globalLimit: number };
  diagnose: { globalCount: number; globalLimit: number };
}

export interface RateLimitConfig {
  id: number;
  configKey: string;
  limitValue: number;
  description: string | null;
  updatedAt: string;
  updatedBy: string | null;
}

export const adminTrialMonitoringApi = {
  getStats: async (days = 7): Promise<FunnelStats> => {
    const response = await apiAxios.get('/admin/trial-monitoring/stats', { params: { days } });
    return response.data;
  },
  getUsageToday: async (): Promise<UsageToday> => {
    const response = await apiAxios.get('/admin/trial-monitoring/usage-today');
    return response.data;
  },
  getRateLimits: async (): Promise<RateLimitConfig[]> => {
    const response = await apiAxios.get('/admin/trial-monitoring/rate-limits');
    return response.data;
  },
  updateRateLimit: async (configKey: string, limitValue: number): Promise<RateLimitConfig> => {
    const response = await apiAxios.put(`/admin/trial-monitoring/rate-limits/${configKey}`, { limitValue });
    return response.data;
  },
};
